import ReactDOM from 'react-dom/client';
import '@fontsource-variable/manrope/index.css';
import '@fontsource-variable/inter/index.css';
import './css/admin-lte-wrapper.css';
import './css/primereact-wrapper.css';
import './css/public.css';
import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  // <React.StrictMode>
      <GoogleOAuthProvider clientId="691490014458-nqrts7tqu7vqsf2g0oufrc76ktau6fc8.apps.googleusercontent.com">
        <App />
      </GoogleOAuthProvider>
  // </React.StrictMode>
);